import React, { Component } from 'react'
import InputNumber from 'rc-input-number'
import measurementTypes from '../../_constants/measurementTypes'
import ConvertQuantity from './ConvertQuantity'

class QtyInput extends Component {

  state = {
    disabled: false,
    readOnly: false,
    value: this.props.defualtValue,
    defualtSubValue: this.props.defualtSubValue || undefined,
  };

  componentDidMount() {

    if (this.props.defualtSubValue !== undefined) {
      this.setState({ subValue: this.props.defualtSubValue })
    }

  }

  onChange = (value) => {

    if (value === 0) {
      this.setState({ value: 0, subValue: 0 }, () => {
        this.props.onChange(0, 0)
      })
    } else {

      const { min, max, disabled, measurementType, subMeasurementType, conversionUnit } = this.props;

      let val = 0;
      let subVal = 0;

      if (conversionUnit !== undefined && subMeasurementType != undefined && measurementType != subMeasurementType) {

        val = ConvertQuantity(value, conversionUnit, 3, 1);

        subVal = value

      } else {

        val = value

        subVal = value

      }

      this.setState({ value: val, subValue: subVal }, () => {
        this.props.onChange(val, subVal)

      })
    }
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.defualtSubValue !== undefined && nextProps.defualtSubValue !== this.state.subValue) {
      this.setState({ subValue: nextProps.defualtSubValue })
    }

    if (nextProps.defualtValue !== undefined && nextProps.defualtValue !== this.state.value) {
      this.setState({ value: nextProps.defualtValue })
    }
    // console.log(nextProps);

  }

  render() {

    const { min, max, disabled, measurementType, subMeasurementType, conversionUnit } = this.props;
    const { value, subValue } = this.state;

    const measurementTypeLabel = measurementType != undefined && measurementTypes.filter(el => el.value === measurementType)[0] ? measurementTypes.filter(el => el.value === measurementType)[0].label : '';
    const subMeasurementTypeLabel = subMeasurementType != undefined ? measurementTypes.filter(el => el.value === subMeasurementType)[0].label : '';

    return (
      <>
        {subMeasurementType != undefined && measurementType != subMeasurementType ?
          <div class={disabled ? "input-group quantity-input-container double" : "input-group quantity-input-container double"}>
            <span class="input-group-addon first">
              {subMeasurementTypeLabel}
            </span>
            <InputNumber
              aria-label="Number input example that demonstrates custom styling"
              min={min}
              max={max}
              value={subValue}
              readOnly={this.state.readOnly}
              onChange={this.onChange}
              // disabled={disabled}
              upHandler={<></>}
              downHandler={<></>}
            />
            <span class="input-group-addon center">

            </span>
            <InputNumber
              aria-label="Number input example that demonstrates custom styling"
              min={min}
              max={max}
              value={value}
              readOnly={this.state.readOnly}
              onChange={this.onChange}
              disabled={disabled}
              upHandler={<></>}
              downHandler={<></>}
            />
            <span class="input-group-addon last">
              {measurementTypeLabel}
            </span>
          </div>
          :
          <div class={disabled ? "input-group quantity-input-container disabled" : "input-group quantity-input-container"}>
            <span class="input-group-addon first">
              {measurementTypeLabel}
            </span>
            <InputNumber
              aria-label="Number input example that demonstrates custom styling"
              min={min}
              max={max}
              value={value}
              readOnly={this.state.readOnly}
              onChange={this.onChange}
              disabled={disabled}
              upHandler={<></>}
              downHandler={<></>}

            />
          </div>
        }
      </>
    );
  }
}
export default QtyInput;
